import { render, staticRenderFns } from "./DividedTask.vue?vue&type=template&id=0cb7cfbf&"
import script from "./DividedTask.vue?vue&type=script&lang=js&"
export * from "./DividedTask.vue?vue&type=script&lang=js&"
import style0 from "./DividedTask.vue?vue&type=style&index=0&id=0cb7cfbf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports